import React from 'react';
import _ from 'lodash';

import component, {classnames} from './component';

export const Tabs = component('Tabs', {

  _wrapChildrenToArray() {
    return _.isArray(this.props.children)
        ? this.props.children
        : [this.props.children]
  },

  getInitialState() {
    var children = this._wrapChildrenToArray();
    const selected = _.find(children, c => c.props.selected === true);
    return {
      selectedTab: selected && selected.props && selected.props.header
        || !this.props.noDefaultSelected && children[0].props.header,
      selectedKey: selected && selected.key
    };
  },

  selectTab(header, key) {
    this.setState({
      selectedTab: header,
      selectedKey: key
    })
  },

  renderTabs(arr) {

    return arr.map((elem, i) => {
      const current = this.state.selectedKey ? elem.key === this.state.selectedKey :
                      elem.props.header === this.state.selectedTab;
      const cls = {
        'Tabs-Header': true,
        'Tabs-Header--Selected': current
      };
      return <div className={classnames(cls)}
                  onClick={this.selectTab.bind(this, elem.props.header, elem.key)}
                  key={elem.key || i}>

        {elem.props.header}
      </div>
    })
  },

  render() {
    var children = this._wrapChildrenToArray();

    var rightLeft = _.partition(children, t =>
                                t.props.stackTo && t.props.stackTo === 'right');

    var SelectedTab = _.find(children, t => t.props.header === this.state.selectedTab);

    return (
      <div className='Tabs'>
        <div className='Tabs-Items'>
          <div className='Tabs-Left'>{this.renderTabs(rightLeft[1])}</div>
          <div className='Tabs-Right'>{this.renderTabs(rightLeft[0])}</div>
        </div>
        <div className='Tabs-Content'>
          {SelectedTab && SelectedTab.props.children}
        </div>
      </div>
    );
  }

});

export const Tab = component('Tab', ({children}) => children);



// WEBPACK FOOTER //
// ./src/components/Tabs.js